import { useContext } from 'react';

import { PromoMessageContext } from '../contexts/PromoMessageProvider';

export const usePromoMessage = () => useContext(PromoMessageContext);
